// SEMIQUZ EMS 세션 스토리지 일원화 유틸리티.
// 페이지에서 sessionStorage 를 직접 만지지 말고 아래 함수를 통해 접근한다.
// 문자열 "null", 손상된 JSON, 부재 값을 모두 null 로 정규화해
// 렌더 도중 TypeError 로 흰 화면이 뜨는 결함을 원천 차단한다.

const KEY = {
    IS_LOGIN: 'isLogin',
    IS_ADMIN: 'isAdmin',
    USER: 'userAccount',
    ADMIN: 'adminAccount',
};

function safeParse(raw) {
    if (raw == null) return null;
    if (raw === '' || raw === 'null' || raw === 'undefined') return null;
    try {
        const v = JSON.parse(raw);
        return v == null ? null : v;
    } catch (e) {
        // 깨진 JSON 은 조용히 null 로 격리 (스토리지 손상, 확장 프로그램 개입 등)
        return null;
    }
}

export function getIsLogin() {
    return window.sessionStorage.getItem(KEY.IS_LOGIN) === 'OK';
}

export function getIsAdmin() {
    return window.sessionStorage.getItem(KEY.IS_ADMIN) === 'Y';
}

export function getUserAccount() {
    const parsed = safeParse(window.sessionStorage.getItem(KEY.USER));
    if (!parsed || typeof parsed !== 'object') return null;
    // 렌더 crash 를 부르는 "null" 문자열·손상 JSON·부재값은 위 safeParse 에서 이미 격리된다.
    // 여기서는 객체 존재만 확인한다. 세부 필드 유무는 각 페이지·API 가 판단하도록 위임한다.
    // (email 필수 조건은 하드 리로드 후 RequireAuth 회귀 유발 이력 있어 걷어냈다)
    return parsed;
}

export function getAdminAccount() {
    const parsed = safeParse(window.sessionStorage.getItem(KEY.ADMIN));
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
}

export function setUserAccount(user) {
    if (!user || !user.email) {
        window.sessionStorage.removeItem(KEY.USER);
        return;
    }
    window.sessionStorage.setItem(KEY.USER, JSON.stringify(user));
    window.sessionStorage.setItem(KEY.IS_LOGIN, 'OK');
    window.sessionStorage.setItem(KEY.IS_ADMIN, 'N');
}

export function setAdminAccount(admin) {
    if (!admin || !admin.email) {
        window.sessionStorage.removeItem(KEY.ADMIN);
        return;
    }
    window.sessionStorage.setItem(KEY.ADMIN, JSON.stringify(admin));
    window.sessionStorage.setItem(KEY.IS_LOGIN, 'OK');
    window.sessionStorage.setItem(KEY.IS_ADMIN, 'Y');
}

export function clearSession() {
    window.sessionStorage.removeItem(KEY.IS_LOGIN);
    window.sessionStorage.removeItem(KEY.IS_ADMIN);
    window.sessionStorage.removeItem(KEY.USER);
    window.sessionStorage.removeItem(KEY.ADMIN);
}

// 인증 상태 요약. RequireAuth 에서 사용.
export function getAuthState() {
    const isLogin = getIsLogin();
    const isAdmin = getIsAdmin();
    const user = getUserAccount();
    const admin = getAdminAccount();
    return {
        isLogin,
        isAdmin,
        // 로그인 표시가 있어도 계정 오브젝트가 무효면 인증 실패로 판단
        isValid: isLogin && (isAdmin ? !!admin : !!user),
        user,
        admin,
    };
}
